/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Updated_FromInputs */

const en_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const fr_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const de_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const it_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const ru_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const es_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const zh_cn2_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const ja_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const hi_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

const pt_pt2_explorer_search_updated_from = /** @type {(inputs: Explorer_Search_Updated_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated from`)
};

/**
* | output |
* | --- |
* | "Updated from" |
*
* @param {Explorer_Search_Updated_FromInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_updated_from = /** @type {((inputs?: Explorer_Search_Updated_FromInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Updated_FromInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_updated_from(inputs)
	if (locale === "de") return de_explorer_search_updated_from(inputs)
	if (locale === "it") return it_explorer_search_updated_from(inputs)
	if (locale === "ru") return ru_explorer_search_updated_from(inputs)
	if (locale === "es") return es_explorer_search_updated_from(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_updated_from(inputs)
	if (locale === "ja") return ja_explorer_search_updated_from(inputs)
	if (locale === "hi") return hi_explorer_search_updated_from(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_updated_from(inputs)
	return en_explorer_search_updated_from(inputs)
});